import { onUnmounted, ref, watch } from 'vue';

type UseScrollRevealOptions = {
    threshold?: number;
    rootMargin?: string;
};

/**
 * Observe un élément HTML et renvoie `visible` = true dès qu'il entre dans le viewport.
 * Utilise IntersectionObserver (SSR-safe). Compatible avec les callback refs (v-for).
 */
export function useScrollReveal(options: UseScrollRevealOptions = {}) {
    const { threshold = 0.15, rootMargin = '0px 0px -60px 0px' } = options;

    const el = ref<HTMLElement | null>(null);
    const visible = ref(false);
    let observer: IntersectionObserver | null = null;

    watch(el, (newEl) => {
        observer?.disconnect();
        if (!newEl || typeof window === 'undefined') return;

        observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    visible.value = true;
                    observer?.disconnect();
                }
            },
            { threshold, rootMargin },
        );

        observer.observe(newEl);
    });

    onUnmounted(() => {
        observer?.disconnect();
    });

    return { el, visible };
}
